<div class="row">
  @for (member of members$ | async; track member) {
    <div class="col-2">
      <app-member-card [member]="member"></app-member-card>
    </div>
  }

</div>
